/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Тип бонуса случайной промо-акции
 * @export
 * @enum {string}
 */
export enum PromoActionBonusType {
  Percent = 'percent',
  Fixed = 'fixed',
  Service = 'service',
}

export function instanceOfPromoActionBonusType(value: any): boolean {
  for (const key in PromoActionBonusType) {
    if (Object.prototype.hasOwnProperty.call(PromoActionBonusType, key)) {
      if (
        PromoActionBonusType[key as keyof typeof PromoActionBonusType] === value
      ) {
        return true
      }
    }
  }
  return false
}

export function PromoActionBonusTypeFromJSON(json: any): PromoActionBonusType {
  return PromoActionBonusTypeFromJSONTyped(json, false)
}

export function PromoActionBonusTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PromoActionBonusType {
  return json as PromoActionBonusType
}

export function PromoActionBonusTypeToJSON(
  value?: PromoActionBonusType | null
): any {
  return value as any
}
